'use client';
import { useLayoutEffect } from 'react';

import useRouter from '@/hooks/useRouter';
import { useSearchParams } from 'react-router';

interface IRedirectProps {
  path: string;
}

function Redirect({ path }: IRedirectProps) {
  const router = useRouter();
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    const allSearchParams = searchParams.toString();
    router.replace(`${path}${allSearchParams ? `?${allSearchParams}` : ''}`);
  }, [router, path, searchParams]);

  return <></>;
}

export default Redirect;
